var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.currencyPrices.length > 0)?_c('h3',[_vm._v("\n    Staffelpreise\n  ")]):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"product-price-table pl-0"},_vm._l((_vm.currencyPrices),function(p){return _c('li',{key:p.id},[_vm._v("\n      "+_vm._s(_vm.$t("components.productPriceTable.item", {
          quantity: p.quantity,
          price: p.price
        }))+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }